import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";
import moment from "moment";

const FundTransferView = () => {
  const { id } = useParams();
  const [transfer, setTransfer] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Http.get(`/accounts/fund-transfers/${id}`)
      .then((res) => {
        setTransfer(res.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Fund Transfer Details</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Transfer Information</h6>
            
            {loading ? (
              <div className="text-center">
                <ProgressSpinner />
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped table-bordered">
                  <tbody>
                    <tr>
                      <th width="200">Date</th>
                      <td>{transfer.date ? moment(transfer.date).format("DD/MM/YYYY") : "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Reference</th>
                      <td>{transfer.reference || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>From Account</th>
                      <td>{transfer.from_account?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>To Account</th>
                      <td>{transfer.to_account?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>{transfer.amount ? `${transfer.amount.toFixed(2)}` : "0.00"}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{transfer.description || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Created By</th>
                      <td>{transfer.created_by?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Created At</th>
                      <td>
                        {transfer.created_at
                          ? moment(transfer.created_at).format("DD/MM/YYYY hh:mm A")
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>
                        {transfer.updated_at
                          ? moment(transfer.updated_at).format("DD/MM/YYYY hh:mm A")
                          : "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundTransferView;